import { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { toast, ToastContainer } from 'react-toastify';
//@ts-ignore
import {db} from '../../utils/firebase.js'
//@ts-ignore
import CryptoJS from 'crypto-js';

const ResetPassword = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    if (
      !formData.email ||
      !formData.password
    ) {
      toast.error("Please fill in all required fields.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  }

  const encryptPassword = (password: string) => {
    return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  };


  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log('Reset Password Data Submitted:', formData);

    if(validate()){
      try {
        const userDocRef = doc(db, "userDetails", formData.email);
        await updateDoc(userDocRef, {
          email: formData.email,
          password: encryptPassword(formData.password)
        });
    
        toast.success("Password updated successfully!");
    
        setFormData({
          email: "",
          password: "",
        });
    
      } catch (error: any) {
        console.error("Error updating password");
        toast.error("The email is not registered with our business, please register user first");
        setFormData({
          email: "",
          password: "",
        });
      }
    }
  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <h2 className="text-xl font-bold mb-6">Reset Password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* New Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700">New Password</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* Reset Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Reset Password
          </button>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;